export enum TestimonialStatus {
  DRAFT = 1,
  PUBLISHED = 2,
}

// API response shape for a single testimonial
export interface Testimonial {
  id: string;
  author_name: string;
  author_title?: string | null;
  content: string;
  profile_image_url?: string | null;
  profile_image?: string | null;
  status: TestimonialStatus;
  created_at: string;
  updated_at: string;
  translations?:
    | Record<
        string,
        Partial<{
          name: string;
          description: string;
          author_title: string;
        }>
      >
    | string;
}

// Standard list response used by /testimonial
export interface TestimonialListResponse {
  data: Testimonial[];
  totalItems?: number;
  total?: number;
  total_items?: number;
  totalPages?: number;
  total_pages?: number;
  currentPage?: number;
  current_page?: number;
}

export interface TestimonialListQueryParams {
  page?: number;
  limit?: number;
  status?: TestimonialStatus;
  search?: string;
}

// Local form state used in CMS create/edit pages
export interface TestimonialFormData {
  id?: string;
  authorName: string;
  authorTitle?: string;
  content: string;
  profileImage?: File | string | null;
  status: TestimonialStatus;
  translations?:
    | Record<
        string,
        Partial<{
          name: string;
          description: string;
          author_title: string;
        }>
      >
    | string;
}

export interface TestimonialTranslationPayload {
  testimonial_id?: string;
  content: string;
  author_title?: string;
  source_language?: string;
}

export interface TestimonialTranslations {
  translations: Record<
    string,
    Partial<{
      content: string;
      author_title: string;
    }>
  >;
  warning_message?: string;
}
